import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

// Resources
import BlogsPage from './pages/BlogsPage';
import BlogPostPage from './pages/BlogPostPage';
import NewsPage from './pages/NewsPage';
import NewsPostPage from './pages/NewsPostPage';
import PublicationsPage from './pages/PublicationsPage';
import PublicationPostPage from './pages/PublicationPostPage';

// Legal Pages
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

// PPC Landing Page
import TrademarkPPCLanding from './pages/TrademarkPPCLanding';

// Trademark Services
import TrademarkSearchPage from './pages/services/TrademarkSearchPage';
import TrademarkMonitoringPage from './pages/services/TrademarkMonitoringPage';
import TrademarkApplicationPage from './pages/services/TrademarkApplicationPage';
import TrademarkClearancePage from './pages/services/TrademarkClearancePage';
import TrademarkTransferPage from './pages/services/TrademarkTransferPage';
import PortfolioManagementPage from './pages/services/PortfolioManagementPage';
import StatementOfUsePage from './pages/services/StatementOfUsePage';
import OfficeActionsPage from './pages/services/OfficeActionsPage';

// Copyright Services
import CopyrightRegistrationPage from './pages/services/CopyrightRegistrationPage';
import CopyrightEnforcementPage from './pages/services/CopyrightEnforcementPage';
import CopyrightLicensingPage from './pages/services/CopyrightLicensingPage';
import CopyrightLitigationPage from './pages/services/CopyrightLitigationPage';
import CopyrightPortfolioPage from './pages/services/CopyrightPortfolioPage';
import DMCAPage from './pages/services/DMCAPage';

// Patent Services
import PatentSearchesPage from './pages/services/PatentSearchesPage';
import PatentOfficeActionsPage from './pages/services/PatentOfficeActionsPage';
import PatentApplicationsPage from './pages/services/PatentApplicationsPage';
import PatentEnforcementPage from './pages/services/PatentEnforcementPage';

// Company Formation Services
import LLCFormationPage from './pages/services/LLCFormationPage';
import CCorpFormationPage from './pages/services/CCorpFormationPage';
import SCorpFormationPage from './pages/services/SCorpFormationPage';
import NonProfitFormationPage from './pages/services/NonProfitFormationPage';

function AppContent() {
  const location = useLocation();
  const isLandingPage = location.pathname === '/lp/' || location.pathname === '/lp';
  
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return (
    <div className="App">
      {!isLandingPage && <Header />}
      <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Trademark Services */}
          <Route path="/services/trademark-search" element={<TrademarkSearchPage />} />
          <Route path="/services/trademark-monitoring" element={<TrademarkMonitoringPage />} />
          <Route path="/services/trademark-application" element={<TrademarkApplicationPage />} />
          <Route path="/services/trademark-clearance" element={<TrademarkClearancePage />} />
          <Route path="/services/trademark-transfer" element={<TrademarkTransferPage />} />
          <Route path="/services/portfolio-management" element={<PortfolioManagementPage />} />
          <Route path="/services/statement-of-use" element={<StatementOfUsePage />} />
          <Route path="/services/office-actions" element={<OfficeActionsPage />} />
          
          {/* Copyright Services */}
          <Route path="/services/copyright-registration" element={<CopyrightRegistrationPage />} />
          <Route path="/services/copyright-enforcement" element={<CopyrightEnforcementPage />} />
          <Route path="/services/copyright-licensing" element={<CopyrightLicensingPage />} />
          <Route path="/services/copyright-assignments-licensing" element={<CopyrightLicensingPage />} />
          <Route path="/services/copyright-litigation" element={<CopyrightLitigationPage />} />
          <Route path="/services/copyright-portfolio" element={<CopyrightPortfolioPage />} />
          <Route path="/services/dmca" element={<DMCAPage />} />
          
          {/* Patent Services */}
          <Route path="/services/patent-searches" element={<PatentSearchesPage />} />
          <Route path="/services/patent-office-actions" element={<PatentOfficeActionsPage />} />
          <Route path="/services/patent-applications" element={<PatentApplicationsPage />} />
          <Route path="/services/patent-enforcement" element={<PatentEnforcementPage />} />
          
          {/* Company Formation Services */}
          <Route path="/services/llc-formation" element={<LLCFormationPage />} />
          <Route path="/services/c-corp-formation" element={<CCorpFormationPage />} />
          <Route path="/services/s-corp-formation" element={<SCorpFormationPage />} />
          <Route path="/services/nonprofit-formation" element={<NonProfitFormationPage />} />
          
          {/* Resources */}
          <Route path="/resources/blogs" element={<BlogsPage />} />
          <Route path="/resources/blogs/:slug" element={<BlogPostPage />} />
          <Route path="/resources/news" element={<NewsPage />} />
          <Route path="/resources/news/:slug" element={<NewsPostPage />} />
          <Route path="/resources/publications" element={<PublicationsPage />} />
          <Route path="/resources/publications/:slug" element={<PublicationPostPage />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          
          {/* PPC Landing Page */}
          <Route path="/lp/" element={<TrademarkPPCLanding />} />
        </Routes>
        {!isLandingPage && <Footer />}
      </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;